<div style="display: flex">
  <div class="col-md-6 p-5">
    <h1 data-cy="error_page">Something went wrong. These are some steps you can take.</h1>
    <div style="padding: 5%">
      <b>Check your file quality</b>
      <br />
      <p>
        Of course you can always try again and sometimes that does the trick, due to our file fixing algorithms. Though, most issues arise out of a bad meshing quality. To improve
        the mesh quality of your (STL) file, you have to adjust your export settings in your CAD software to a more injection molding suited mesh. Click on this link to get further
        information on the
        <a (click)="openCADRequirementsDialog()">
          <span style="color: #21a0d2; cursor: pointer">CAD file requirements</span>
        </a>
        .
      </p>

      <b>Upload STP file format</b>
      <br />
      <p>
        Unsure how to improve the mesh quality of your STL file? If yes, you could try to upload the same model in STP format. Then molded will provide a meshing our algorithms
        seem fit for you. Note: This way you will have no control on the granularity of the mesh and therefore on the quality of analysis.
      </p>

      <b>Request support</b>
      <br />
      <p>
        You are stuck and don't know why the analysis is still failing? No worries, you are not alone. You can request
        <span style="color: #21a0d2; cursor: pointer" (click)="requestSupportDialog()">support</span>
        on the information card on the right. As soon as we have located or fixed the issue, you will receive an e-mail from us. You can withdraw the request and therefore the
        access rights to your project any time.
      </p>
    </div>
  </div>

  <div style="display: block; padding: 100px">
    <div class="disable-focus">
      <div class="">
        <img src="assets/img/support.jpg" alt="Guide image" width="100%" />
      </div>
      <!-- <div class="carousel-caption-title">
        <span><i>Ultrasim</i></span>
      </div> -->
    </div>
    <div class="carousel-content">
      <p><b style="color: orange; font-size: 16px">Do you need further support?</b></p>
      <p>
        <b>
          Do you need
          <button class="carousel-info-button disable-focus">
            <b style="color: #5177b5; font-size: 16px">simulation expertise</b>
          </button>
          or advice on
          <button class="carousel-info-button disable-focus">
            <b style="color: #5177b5">suitable materials</b>
          </button>
          ?
        </b>
      </p>
      <span>
        If you need further help with your project, you can click on the button below, which will lead you to the 'request support' form. There you will have the opportunity to
        request further simulation support or assistance for the choice of material.
      </span>
      <div class="text-center mb-2" style="margin-top: 30px">
        <usimweb-button text="Support" (btnClick)="requestSupportDialog()" [width]="150"></usimweb-button>
      </div>
    </div>
  </div>
</div>
